module.exports = __webpack_public_path__ + "img/Icon__No legal proceedsv.68d09108.svg";